import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        // Scroll to top when route changes (only on client)
        if (typeof window !== 'undefined') {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'instant',
            });
        }
    }, [pathname]);
    return null;
};
export default ScrollToTop;
